import React from 'react'
import Footer from '../components/Footer'
import Header from './Header'

const TemplateWrapper = ({ children }) => {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  )
}

export default TemplateWrapper
